export const Config = {
  MODE: process.env.REACT_APP_MODE,
  country: process.env.REACT_APP_COUNTRY,
  country_short: process.env.REACT_APP_COUNTRY_SHORT,
  timezone: process.env.REACT_APP_TIME_ZONE,
  API_BASE_URL: function () {
    return process.env.REACT_APP_API_BASE_URL;
  },
  API_ADMIN_BASE_URL: function () {
    return process.env.REACT_APP_API_ADMIN_BASE_URL;
  },
  currency: {
    type: process.env.REACT_APP_CURRENCY || 'INR',
    base: parseInt(process.env.REACT_APP_CURRENCY_BASE) || 100,
  },
  payment: {
    tax: {
      roi_gst: parseFloat(process.env.REACT_APP_GST_ROI) || 18,
      roi_tds: parseFloat(process.env.REACT_APP_TDS_ROI) || 10,
    },
    razorpay: {
      key: process.env.REACT_APP_RAZORPAY_KEY || 'missing_razorpay_key',
      prefill: {
        name: process.env.REACT_APP_RAZORPAY_NAME,
        email: process.env.REACT_APP_RAZORPAY_EMAIL,
        contact: process.env.REACT_APP_RAZORPAY_CONTACT,
      },
    },
  },
  social: {
    fb: {
      client_id: process.env.REACT_APP_FB_CLIENT_ID,
      redirect_uri: process.env.REACT_APP_FB_REDIRECT_URI,
      scope: process.env.REACT_APP_FB_SCOPE,
      version: process.env.REACT_APP_FB_VERSION,
    },
    yt: {
      client_id: process.env.REACT_APP_YT_CLIENT_ID,
      scope: process.env.REACT_APP_YT_SCOPE,
      access_type: process.env.REACT_APP_YT_ACCESS_TYPE,
    },
  },
};
